import clsx from 'clsx';
import { useState } from 'react';

import {
  FagmoblerAlgoliaProductVariant,
  FagmoblerAlgoliaProduct,
} from '@fagmobler/types';

import Link from 'next/link';
import { Button, ImageMissing, Price } from '@fagmobler/ui';
import DefaultImage from '@/components/images/DefaultImage';
import Image from 'next/image';
import { missingImageUrls } from '@/lib/utils/missingImageUrls';

export type RelatedProductsProps = {
  products: FagmoblerAlgoliaProduct[];
  current: FagmoblerAlgoliaProductVariant['objectID'];
  basePath?: string;
};

export function RelatedProducts({
  products,
  current,
  basePath,
}: RelatedProductsProps) {
  const sortedProducts = products.sort((a, b) => {
    return a.objectID.localeCompare(b.objectID);
  });

  const [expanded, setExpanded] = useState(products.length <= 5);

  if (!basePath) return null;

  return (
    <section className={clsx('mb-8', 'print:hidden')}>
      <header>
        <h4 className={clsx('hd-base', 'my-4')}>Relaterte produkt</h4>
      </header>

      <ul
        className={clsx('-mx-5 px-5 pt-5 -mt-5', {
          'max-h-[17.5rem] overflow-hidden ': !expanded,
        })}
      >
        {sortedProducts.map((product, i) => {
          if (!product.historicPath) return null;
          const isCurrent = product.objectID === current;
          const hasImage =
            product.image && !missingImageUrls.includes(product.image);
          return (
            <li
              className={clsx(
                'odd:bg-neutral-30',
                'py-2',
                'px-2',
                'pr-2',
                'rounded',
                {
                  'outline outline-2 outline-offset-2 outline-neutral-60':
                    isCurrent,
                }
              )}
              key={product.objectID}
            >
              <Link legacyBehavior href={`${basePath}/${product.objectID}`}>
                <a
                  className={clsx(
                    'flex',
                    'justify-between',
                    'items-center',

                    // 'underline underline-offset-2',
                    {
                      'font-bold': product.objectID === current,
                    }
                  )}
                >
                  <span className="flex">
                    {product.image && (
                      <div className={clsx('mr-4')}>
                        {hasImage ? (
                          <Image
                            className="mix-blend-darken object-contain"
                            src={product.image}
                            alt={product.posterName || 'Bilde'}
                            height="32"
                            width="32"
                          />
                        ) : (
                          <ImageMissing size="sm" />
                        )}
                      </div>
                    )}
                    <div>
                      <div>{product.posterName}</div>
                      <div className="body-xs">{product.posterDescription}</div>
                    </div>
                  </span>

                  <div className="no-underline">
                    <Price
                      withStickers={false}
                      memberPrice={product?.campaignPrice}
                      price={product.price}
                      size="xs"
                      horizontal
                    />
                  </div>
                </a>
              </Link>
            </li>
          );
        })}
      </ul>
      {!expanded && (
        <div className="border-t-2 border-neutral-50 py-4">
          <Button variant="ghost" onClick={() => setExpanded(true)}>
            Vis alle ({products.length})
          </Button>
        </div>
      )}
    </section>
  );
}

export default RelatedProducts;
